import React from 'react';
import { QUESTION_CATEGORIES, QUESTION_DIFFICULTIES } from './constants';

/**
 * QuestionFilters - search bar + category/difficulty selectors.
 *
 * Props:
 *   value     - { search, category, difficulty, active }
 *   onChange  - (next) => void  (callers should debounce upstream if needed)
 */
export default function QuestionFilters({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });

  return (
    <div className="flex flex-wrap items-center gap-2 card p-3 rounded-xl">
      <input
        type="search"
        value={value.search || ''}
        onChange={(e) => set({ search: e.target.value })}
        placeholder="Search title or description…"
        className="flex-1 min-w-[220px] rounded-lg border border-slate-200 px-3 py-2
                   text-sm placeholder:text-slate-400 bg-white focus:outline-none
                   focus:ring-2 focus:ring-teal-500/25 focus:border-teal-500"
      />
      <select
        value={value.category || ''}
        onChange={(e) => set({ category: e.target.value || undefined })}
        className="rounded-lg border border-slate-200 px-2.5 py-2 text-sm bg-white text-slate-800"
      >
        <option value="">All categories</option>
        {QUESTION_CATEGORIES.map((c) => (
          <option key={c.value} value={c.value}>{c.label}</option>
        ))}
      </select>
      <select
        value={value.difficulty || ''}
        onChange={(e) => set({ difficulty: e.target.value || undefined })}
        className="rounded-lg border border-slate-200 px-2.5 py-2 text-sm bg-white text-slate-800"
      >
        <option value="">Any difficulty</option>
        {QUESTION_DIFFICULTIES.map((d) => (
          <option key={d.value} value={d.value}>{d.label}</option>
        ))}
      </select>
      <label className="flex items-center gap-1.5 text-xs text-slate-600 px-1">
        <input
          type="checkbox"
          checked={value.active !== false}
          onChange={(e) => set({ active: e.target.checked ? undefined : false })}
          className="rounded border-slate-300"
        />
        Hide archived
      </label>
    </div>
  );
}
